import React from "react";

import { StyledPageWrapper } from "./styled";

const PageWrapper = ({ styles, children }) => (
  <StyledPageWrapper styles={styles}>{children}</StyledPageWrapper>
);

export default PageWrapper;
